"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyAxiosRetry = void 0;
const retry_axios_1 = require("retry-axios");
function applyAxiosRetry(instance, options) {
    instance.interceptors.request.use((config) => {
        config.raxConfig = config.raxConfig || { instance, ...options };
        return config;
    });
    (0, retry_axios_1.attach)(instance);
    return instance;
}
exports.applyAxiosRetry = applyAxiosRetry;
